const url = 'apihrms.aviquon.com';
const httpProtocol = 'https://';

export const environment = {
  production: false,
  apiURL: `${httpProtocol}${url}/`,
};
